import { AxiosResponse } from "axios";
import { TDateRange, TDetailedPolygons, TVesselCurrentStatus, TVesselInfo } from "./mapTypes";
import { authApiV2, axiosWithToast } from "../../axiosWrapper";

export const getVesselsLastSignalByImoNumbers = async (imoList: number[], date: string, yearMonth: number): Promise<TVesselInfo> => {
    const endpoint = `/vessels-last-signal`;
    try {
        const response: AxiosResponse<any> = await axiosWithToast({
            method: 'POST',
            url: endpoint,
            withCredentials: true,
            data: { imoList, date, yearMonth },
        }, "Retrieving data...", "Data retrieved successfully", 1000);

        return Promise.resolve(response.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselLastVoyagesByImoNumbers = async (imoNumbers: number[], startDate: string, endDate: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-last-voyages`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startDate: startDate, endDate: endDate });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselLastStoppageEventsByImoNumber = async (imoNumber: number, startDate: string, endDate: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-last-stoppage-events`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber: imoNumber, startDate: startDate, endDate: endDate } });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselLastPortCallsByImoNumber = async (imoNumber: number, startDate: string, endDate: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-last-port-calls`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber: imoNumber, startDate: startDate, endDate: endDate } });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselOngoingVoyageSignalsByImoNumber = async (imoNumber: number, date: string,): Promise<TVesselInfo> => {
    const endpoint = `/vessel-ongoing-voyage-signals`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber: imoNumber, date: date } });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselVoyageDailySignalsByImoNumbers = async (imoNumbers: number[], startDate: string, endDate: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-voyage-daily-signals`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, startDate: startDate, endDate: endDate });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselDailyPositionsByImoNumbers = async (imoNumbers: number[], date: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-daily-positions`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, date: date });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselOngoingVoyageDailySignalsByImoNumbers = async (imoNumbers: number[], date: string): Promise<TVesselInfo> => {
    const endpoint = `/vessel-ongoing-voyage-daily-signals`;
    try {
        const data = await authApiV2.post(endpoint, { imoNumbers: imoNumbers, date: date });
        return Promise.resolve(data.data as TVesselInfo);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDateRange = async (): Promise<TDateRange> => {
    const endpoint = `/date-range`;
    try {
        const data = await authApiV2.get(endpoint);
        return Promise.resolve(data.data as TDateRange);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getDetailedPolygons = async (): Promise<TDetailedPolygons> => {
    const endpoint = `/detailed-polygons`;
    try {
        const response = await authApiV2.get(endpoint);

        return Promise.resolve(response.data as TDetailedPolygons);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVesselCurrentStatusByImoNumber = async (imoNumber: number): Promise<TVesselCurrentStatus> => {
    const endpoint = `/vessel-current-status`;
    try {
        const data = await authApiV2.get(endpoint, { params: { imoNumber } });
        return Promise.resolve(data.data as TVesselCurrentStatus);
    } catch (err) {
        return Promise.reject(err);
    }
};